import angular from 'angular';

class SharedService {
    constructor() {
        'ngInject';
        this.refreshingToken = false;
        this.loader = {
            visible: false
        };
    }
}

const sharedServiceModule = angular.module('st.services.shared', [])
    .service('sharedService', SharedService)
    .name;

export default sharedServiceModule;


// WEBPACK FOOTER //
// ./client/app/services/shared.service.js